import { render } from "./PremiumChoice.vue?vue&type=template&id=e00fa27e"
import script from "./PremiumChoice.vue?vue&type=script&lang=js"
export * from "./PremiumChoice.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__